<div class="row no-gutters">
    <div class="col-sm-12">
        <mat-radio-group *ngIf="!asCode"
                         [(ngModel)]="gender"
                         (change)="onChange()"
                         [disabled]="disabled">
            <mat-radio-button id="{{idPrefix}}gender.input_radio.male"
                              labelPosition="after"
                              value="{{ Gender.MALE_LONG }}"
                              style="margin-right: 10px; margin-top: 10px;">
                {{ 'gender.mr' | translate }}
            </mat-radio-button>

            <mat-radio-button id="{{idPrefix}}gender.input_radio.female"
                              labelPosition="after"
                              value="{{ Gender.FEMALE_LONG }}"
                              style="margin-right: 10px;">
                {{ 'gender.ms' | translate }}
            </mat-radio-button>

            <mat-radio-button id="{{idPrefix}}gender.input_radio.unknown"
                              labelPosition="after"
                              value="{{ Gender.UNKNOWN }}">
                {{ 'gender.not_specified' | translate }}
            </mat-radio-button>

        </mat-radio-group>

        <mat-radio-group *ngIf="asCode"
                         [(ngModel)]="gender"
                         (change)="onChange()"
                         [disabled]="disabled">
            <mat-radio-button id="{{idPrefix}}gender.input_radio.as_code_male"
                              labelPosition="after"
                              value="{{ Gender.MALE }}"
                              style="margin-right: 10px; margin-top: 10px;">
                {{ 'gender.mr' | translate }}
            </mat-radio-button>

            <mat-radio-button id="{{idPrefix}}gender.input_radio.as_code_female"
                              labelPosition="after"
                              value="{{ Gender.FEMALE }}"
                              style="margin-right: 10px;">
                {{ 'gender.ms' | translate }}
            </mat-radio-button>

            <mat-radio-button id="{{idPrefix}}gender.input_radio.as_code_unknown"
                              labelPosition="after"
                              value="{{ Gender.UNKNOWN }}">
                {{ 'gender.not_specified' | translate }}
            </mat-radio-button>

        </mat-radio-group>
    </div>
</div>
